import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

export default function ContactPage() {
  return (
    <>
        <section className="relative py-16 px-6 bg-gradient-to-r from-[#fdfdfd] to-[#eef5f9] overflow-hidden">
        {/* Decorative Background Bubbles */}
        <div className="absolute -top-16 -left-16 w-96 h-96 bg-[#ff7a00]/10 rounded-full blur-3xl z-0"></div>

        
      <div className="container mx-auto max-w-6xl">
        {/* Page Heading */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-[#055862] mb-4" style={{ textShadow: '2px 2px 6px rgba(0, 0, 0, 0.15)' }}>Get in Touch</h1>
          <p className="text-gray-600 max-w-xl mx-auto">
            We're here to answer your questions, assist with setup, and ensure you get the most out of iDisKover.
          </p>
        </div>

        {/* Grid Layout: Contact Info + Form */}
        <div className="grid md:grid-cols-2 gap-10">
          
          {/* LEFT: Contact Info */}
          <div className="bg-white shadow-md rounded-xl p-8">
            <h2 className="text-xl font-semibold text-[#055862] mb-6">Contact Information</h2>
            <ul className="space-y-6 text-gray-700 text-base">
              <li className="flex items-start gap-4">
                <FaMapMarkerAlt className="text-2xl text-[#ff7a00] mt-1" />
                <span>
                  Informatics Publishing Limited, 194, RV Road,<br />
                  Basavanagudi, Bengaluru - 560004, Karnataka, India.
                </span>
              </li>
              <li className="flex items-start gap-4">
                <FaEnvelope className="text-2xl text-[#ff7a00] mt-1" />
                <a href="mailto:idiskover@informaticsglobal.ai" className="hover:underline">
                  idiskover@informaticsglobal.ai
                </a>
              </li>
              <li className="flex items-start gap-4">
                <FaPhoneAlt className="text-2xl text-[#ff7a00] mt-1" />
                <span>+91 9973565615, 9900236751 (Mon–Sat, 9AM–7PM IST)</span>
              </li>
            </ul>
          </div>

          {/* RIGHT: Contact Form */}
          <div className="bg-white shadow-md rounded-xl p-8">
            <h2 className="text-xl font-semibold text-[#055862] mb-6">Send Us a Message</h2>
            <form className="space-y-6">
              <div>
                <label className="block mb-2 font-medium text-sm text-[#055862]">Full Name</label>
                <input
                  type="text"
                  placeholder="Your name"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff7a00] outline-none"
                />
              </div>
              <div>
                <label className="block mb-2 font-medium text-sm text-[#055862]">Email Address</label>
                <input
                  type="email"
                  placeholder="you@example.com"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff7a00] outline-none"
                />
              </div>
              <div>
                <label className="block mb-2 font-medium text-sm text-[#055862]">Your Message</label>
                <textarea
                  rows="5"
                  placeholder="Type your message here..."
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff7a00] outline-none resize-none"
                />
              </div>
              <button
                type="submit"
                className="bg-gradient-to-r from-[#055862] to-[#ff7a00] text-white px-6 py-3 rounded-md font-medium shadow hover:opacity-90 transition"
              >
                Submit Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <section className="relative py-16 px-6 bg-gradient-to-r from-[#fdfdfd] to-[#eef5f9] overflow-hidden">
    {/* Decorative Background Bubbles */}
    <div className="absolute -top-16 -left-16 w-96 h-96 bg-[#ff7a00]/10 rounded-full blur-3xl z-0"></div>
    <div className="absolute top-1/3 left-1/2 w-72 h-72 bg-[#055862]/10 rounded-full blur-2xl z-0"></div>
    <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#ff7a00]/20 rounded-full blur-3xl z-0"></div>

    <div className="container mx-auto max-w-6xl text-center">
        <h2 className="text-3xl font-bold text-[#055862] mb-6">Our Location</h2>
        <p className="text-gray-600 mb-10">
        Visit our office at the heart of Bengaluru's knowledge and innovation hub.
        </p>
        <div className="overflow-hidden rounded-xl shadow-lg border border-gray-200">
        <iframe
            title="Informatics Publishing Limited Office Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.5087946027793!2d77.57776997358842!3d12.939261415589444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae162a55555555%3A0x14ae6b9af6563d4c!2sInformatics%20India%20Ltd!5e0!3m2!1sen!2sin!4v1745399205969!5m2!1sen!2sin"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full h-[400px]"
        ></iframe>
        </div>
    </div>
    </section>
</>
    
  );
}
